import componentShell from "./shell"
import ProductFilter from "@/product_filter/containers/product_filter"

export default componentShell(ProductFilter)
